import { applyPagination } from "./pagination";
import { updateUrlFromState } from "../../utils/url.write";
import { getInitialSortField } from "../../utils/misc";
import { setAppLoadingPromise } from "./loading";

export const SET_SORT = 'SET_SORT';
export const CALCULATE_SORTED_ROW_KEYS = 'CALCULATE_SORTED_ROW_KEYS';


export function setSortAndApply(columnName) {
    /**
     * Action that sets the sorting and then applies the sorting.
     *
     * */
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            dispatch( setSort(columnName) );
            resolve()
        }).then( () => dispatch( applySort() ))
    }
}

function setSort(columnName) {
    return {
        type: SET_SORT,
        columnName
    }
}

export function resetSort() {
    return function (dispatch, getState) {
        const { immutableBaseData } = getState();
        return new Promise(function (resolve, reject) {
            dispatch( setSort( getInitialSortField(immutableBaseData) ) );
            resolve()
        })
    }
}

export function applySort() {
    /**
     * Combines actions required to apply sorting to the data set.
     *
     * */

    return function (dispatch, getState) {
        dispatch( setAppLoadingPromise() )
        .then(() => {
            return new Promise(function (resolve, reject) {
                const { mutableSearching, mutableBaseData, mutableSorting } = getState();
                if ( mutableSorting.sortBy === null ) {
                    dispatch( resetSort() )
                }
                dispatch( calculateSortedRowKeys(
                    mutableSearching.searchedRowKeys,
                    mutableBaseData.rows,
                ) );
                resolve()
            })
        }).then(
            () => {
                // we don't care what order these two occur in; they just need to happen after we apply the search
                updateUrlFromState(getState());
                dispatch( applyPagination() )  // we changed the searched data so we need to paginate it
            }
        )
    }
}

function calculateSortedRowKeys(initialRowKeys, rows) {
    return {
        type: CALCULATE_SORTED_ROW_KEYS,
        initialRowKeys,
        rows,
    }
}